let browserLanguage = navigator.browserLanguage
  ? navigator.browserLanguage
  : navigator.language

if (browserLanguage.indexOf('zh') > -1) {
  if (browserLanguage.indexOf('TW') > -1) {
    browserLanguage = 'zh-TW'
  } else {
    browserLanguage = 'zh-CN'
  }
} else {
  browserLanguage = 'en-US'
}
//需注释部分
// browserLanguage = 'zh-CN'
let localLanguage = localStorage.getItem('language')

if (localLanguage === 'zh') {
  localLanguage = 'zh-CN'
} else if (localLanguage === 'en') {
  localLanguage = 'en-US'
}
if (localLanguage) {
  browserLanguage = localLanguage
}

// 从 localStorage 初始化 goodLinks
const getInitialGoodLinks = () => {
  try {
    const stored = localStorage.getItem('goodLinks')
    return stored ? JSON.parse(stored) : null
  } catch (e) {
    return null
  }
}

// 从 localStorage 初始化 specificationLinks
const getInitialSpecificationLinks = () => {
  try {
    const stored = localStorage.getItem('specificationLinks')
    return stored ? JSON.parse(stored) : null
  } catch (e) {
    return null
  }
}

const initialState = {
  language: browserLanguage,
  goodLinks: getInitialGoodLinks(),
  specificationLinks: getInitialSpecificationLinks(),
}
console.log(initialState, 'initialLanguage')
const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CHANGE_LANGUAGE':
      return { ...state, language: action.val }
    case 'SET_GOOD_LINKS':
      return { ...state, goodLinks: action.payload }
    case 'SET_SPECIFICATION_LINKS':
      return { ...state, specificationLinks: action.payload }
    default:
      return state
  }
}

export default rootReducer
